import VLogger from '@3vjia/v-logger';

let vlogger = null;

function init(params) {
  if (!vlogger) {
    vlogger = new VLogger(Object.assign({}, params, {
      websiteType: VLogger.getWebsiteType(),
      disablePageview: true,
      disableUploadEvent: true,
    }));
  }
}

function click(params) {
  if (vlogger && typeof vlogger.click === 'function') {
    vlogger.click(params);
  } else {
    console.info('[vlogger] donot init'); // eslint-disable-line
  }
}

function event(params) {
  if (vlogger && typeof vlogger.event === 'function') {
    vlogger.event(params);
  } else {
    console.info('[vlogger] donot init'); // eslint-disable-line
  }
}

export function pageview() {
  if (vlogger && typeof vlogger.pageview === 'function') {
    vlogger.pageview();
  } else {
    console.info('[vlogger] donot init'); // eslint-disable-line
  }
}

export default {
  init,
  pageview,
  click,
  event,
};
